import type { DeskStatus } from './types'

/** A control's text: the busy text while it is the one pressed and the screen is busy. */
export function controlText(pressed: { id: string; text: string } | null, busy: boolean, id: string, label: string) {
  return busy && pressed?.id === id ? pressed.text : label
}

/** The control of a verb on the Counter's action row. */
export const verbControlId = (key: string) => `verb:${key}`

/** A paused desk's one verb, running: Cancel withdraws a pending ask, Back ends a break. */
export function pausedBusyKey(status: DeskStatus) {
  return status === 'pending' ? 'counter.busy.cancelling' : 'counter.busy.resuming'
}
